import { render, staticRenderFns } from "./ExternalDepartGroup.vue?vue&type=template&id=5f3341be&scoped=true&"
import script from "./ExternalDepartGroup.vue?vue&type=script&lang=js&"
export * from "./ExternalDepartGroup.vue?vue&type=script&lang=js&"
import style0 from "./ExternalDepartGroup.vue?vue&type=style&index=0&id=5f3341be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3341be",
  null
  
)

export default component.exports